export default "__VITE_ASSET__il4BM_Fs__"